<div class="alert status" [style.margin]="margin" [class.has-actions]="hasActions"
    *ngIf="status != null && visible" [ngClass]="status.type"
    >
    <i class="fas fa-sync-alt fa-spin mr-2" *ngIf="status.load"></i>
    {{ status.text }}
    <div class="actions">
        <button class="btn btn-default" *ngFor="let btn of status.actions"
            (click)="btn.handler($event)">{{ btn.text }}
        </button>
    </div>
</div>
